import { Reducer } from "@reduxjs/toolkit"
import { EstadoRequisicao } from "store/types"
import { ResponseError } from "view/component/MensagensErroServidor/ErroServidor.utils"
import { AriaSort } from "view/component/Tabela/model/OrdemColunaTabela"
import { ServidoresAction } from "./Servidores.action"
import { ServidoresActionTypes, ServidoresState } from "./Servidores.types"


const estadoInicial: ServidoresState = {
  estado: EstadoRequisicao.OCIOSO,
  erros: undefined,
  elementos: [],

  filtros: {},
  ordem: {ordem: AriaSort.Ascending, coluna: "nome"},
  pagina: {
    atual: 1,
    total: 1
  }
}


export const servidoresReducer: Reducer<ServidoresState, ServidoresActionTypes> = (state = estadoInicial, action): ServidoresState => {

  if (ServidoresAction.lista._carregar.pending.match(action)) {
    const { acao, queryParams: queryParamsSolicitados, ordem } = action.meta.arg;
    
    const paginaAtual = acao === 'novaBusca'
      ? 0
      : state.pagina.atual;

    const totalPaginas = acao === 'novaBusca'
      ? 1  // Não se sabe quantas páginas são, então considera como sendo somente uma única página
      : state.pagina.total;

    const filtros = acao === 'novaBusca'
      ? queryParamsSolicitados
      : state.filtros;

    return {
      ...state,
      estado: EstadoRequisicao.CARREGANDO,
      erros: undefined,
      elementos: state.elementos,

      filtros: filtros ?? {},
      ordem: ordem ?? state.ordem,
      pagina: {
        atual: paginaAtual,
        total: totalPaginas
      },
    }
  } else if (ServidoresAction.lista._carregar.fulfilled.match(action)) {
    return {
      ...state,
      estado: EstadoRequisicao.BEM_SUCEDIDO,
      elementos: action.payload.content,

      pagina: {
        atual: action.payload.pageable.pageNumber,
        total: action.payload.totalPages
      },
    }
  } else if (ServidoresAction.lista._carregar.rejected.match(action)) {
    return {
      ...state,

      estado: EstadoRequisicao.FALHOU,
      erros: action.payload as ResponseError,
      elementos: []
    }
  }

  return state;
}
